import { type FC } from 'react';
import { Box, Stack } from '@mui/material';

import { GeneralFields } from '#apps/client-web/features/audit-form-background/components/general-fields';
import { EnvelopeFields } from '#apps/client-web/features/audit-form-background/components/envelope-fields';
import { MainBreakerFields } from '#apps/client-web/features/audit-form-background/components/main-breaker-fields';
import { ControlsFields } from '#apps/client-web/features/audit-form-background/components/control-fields';
import { SpaceHeatingFields } from '#apps/client-web/features/audit-form-background/components/space-heating-fields';
import { SpaceCoolingFields } from '#apps/client-web/features/audit-form-background/components/space-cooling-fields';
import { VentilationFields } from '#apps/client-web/features/audit-form-background/components/ventilation-fields';
import { DCWFields } from '#apps/client-web/features/audit-form-background/components/dcw-fields';
import { DHWFields } from '#apps/client-web/features/audit-form-background/components/dhw-fields';
import { LightingFields } from '#apps/client-web/features/audit-form-background/components/lighting-fields';
import { BuildingAndSystemsFields } from '#apps/client-web/features/audit-form-background/components/building-and-systems-fields';
import { OtherFields } from '#apps/client-web/features/audit-form-background/components/other-fields';

import { type EditAuditFormBackground } from './types';

export type AuditFormBackgroundPageRendererProps = {
  form: EditAuditFormBackground;
  isPending: boolean;
  onSubmit: () => void;
};

export const AuditFormBackgroundPageRenderer: FC<
  AuditFormBackgroundPageRendererProps
> = ({ form, isPending, onSubmit }) => {
  const { control, setValue } = form;
  const disableForm = isPending;

  return (
    <Box
      component="form"
      onSubmit={onSubmit}
      display="flex"
      flexDirection="column"
      flex={1}>
      <Stack sx={{ mt: 2 }} flex={1}>
        <GeneralFields
          control={control}
          setValue={setValue}
          disableForm={disableForm}
        />
        <EnvelopeFields control={control} disableForm={disableForm} />
        <MainBreakerFields control={control} disableForm={disableForm} />
        <ControlsFields control={control} disableForm={disableForm} />
        <SpaceHeatingFields control={control} disableForm={disableForm} />
        <SpaceCoolingFields control={control} disableForm={disableForm} />
        <VentilationFields control={control} disableForm={disableForm} />
        <DCWFields control={control} disableForm={disableForm} />
        <DHWFields control={control} disableForm={disableForm} />
        <LightingFields control={control} disableForm={disableForm} />
        <BuildingAndSystemsFields control={control} disableForm={disableForm} />
        <OtherFields control={control} disableForm={disableForm} />
      </Stack>
    </Box>
  );
};
